export const dashboardSasEnabled = true;

const dashboardItemConfig = (router) => {
  const userParam = router.currentRoute.params['user'];

  const ViewAction = (jobnoKey, link) => {
    return {
      label: 'View',
      key: 'view',
      clickFunction: (item) => {
        router.push(`/Home/${userParam}${link}?View=${item[jobnoKey]}`);
      },
    };
  };

  const EditAction = (jobnoKey, link) => ({
    label: 'Edit',
    key: 'edit',
    clickFunction: (item) => {
      router.push(`/Home/${userParam}${link}?Edit=${item[jobnoKey]}`);
    },
  });

  const ViewEditSet = (jobnoKey, link) => [ViewAction(jobnoKey, link), EditAction(jobnoKey, link)];

  const TasUpdate = (jobnoKey) => {
    return {
      label: 'TAS',
      key: 'tas',
      clickFunction: (item) => router.push(`/Home/${userParam}/Status/${encodeURIComponent(item[jobnoKey])}`),
    };
  };

  const dashboard = [
    {
      title: 'Universal Search',
      key: 'search',
      icon: 'https://dsmlib.logistics.systems/Icons/Search.png',
      type: ['Search'],
      controlKey: 'WidgetSearch',
      table: [
        {
          label: 'Haulage',
          key: 'haulage',
          controlKey: 'WidgetSearchHaulage',
          actions: [...ViewEditSet('primaryValue', '/Haulage/Haulage Job')],
        },
        {
          label: 'Trucking Job',
          key: 'trucking',
          controlKey: 'WidgetSearchTrucking',
          actions: [...ViewEditSet('primaryValue', '/Trucking/Trucking Job')],
        },
        {
          label: 'Workshop Job',
          key: 'workshopjob',
          controlKey: 'WidgetSearchWorkshopJob',
          actions: [...ViewEditSet('primaryValue', '/Workshop/WorkshopJob')],
        },
        {
          label: 'Employee',
          key: 'employee',
          controlKey: 'WidgetSearchEmployee',
          actions: [...ViewEditSet('primaryValue', '/MasterFiles/ProfileMaster/Employee')],
        },
        {
          label: 'Vehicle',
          key: 'vehicle',
          controlKey: 'WidgetSearchVehicle',
          actions: [...ViewEditSet('primaryValue', '/MasterFiles/OperationMaster/Vehicle')],
        },
        {
          label: 'Import Jobs',
          key: 'freightimport',
          controlKey: 'WidgetSearchFreightImport',
          actions: [...ViewEditSet('primaryValue', '/FreightForwarding/Import Job'), TasUpdate('primaryValue')],
        },
        {
          label: 'Export Jobs',
          key: 'freightexport',
          controlKey: 'WidgetSearchFreightExport',
          actions: [...ViewEditSet('primaryValue', '/FreightForwarding/Export Job'), TasUpdate('primaryValue')],
        },
      ],
    },
    {
      title: 'Quick Actions',
      key: 'buttons',
      icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-user-group-man-man-64.png',
      type: ['Buttons'],
      controlKey: 'WidgetButtons',
      buttons: [
        {
          label: 'New Import Job',
          key: 'freightImportNew',
          link: '/FreightForwarding/Import Job?New',
          controlKey: 'WidgetButtonFreightImportNew',
        },
        {
          label: 'New Export Job',
          key: 'freightExportNew',
          link: '/FreightForwarding/Export Job?New',
          controlKey: 'WidgetButtonFreightExportNew',
        },
        {
          label: 'New Delivery Note',
          key: 'freightDeliveryNoteNew',
          link: '/FreightForwarding/Delivery Notes?New',
          controlKey: 'WidgetButtonDeliveryNoteNew',
        },
        { label: 'New ROT', key: 'ROTNew', link: '/FreightForwarding/ROT?New', controlKey: 'WidgetButtonROTNew' },
        {
          label: 'Haulage Job Listing',
          key: 'haulage',
          link: '/Haulage/Haulage Job',
          controlKey: 'WidgetButtonHaulage',
        },
        {
          label: 'New Haulage Job',
          key: 'haulageNew',
          link: '/Haulage/Haulage Job?New',
          controlKey: 'WidgetButtonHaulageNew',
        },
        {
          label: 'Workshop Job Listing',
          key: 'workshopJob',
          link: '/Workshop/WorkshopJob',
          controlKey: 'WidgetButtonWorkshopJob',
        },
        {
          label: 'New Workshop Job',
          key: 'workshopJobNew',
          link: '/Workshop/WorkshopJob?New',
          controlKey: 'WidgetButtonWorkshopJobNew',
        },
        {
          label: 'Part Inventory Listing',
          key: 'partInventory',
          link: '/Workshop/PartInventory',
          controlKey: 'WidgetButtonPartInventory',
        },
        {
          label: 'New Part Inventory',
          key: 'partInventoryNew',
          link: '/Workshop/PartInventory?New',
          controlKey: 'WidgetButtonPartInventoryNew',
        },
      ],
    },
    {
      title: 'Notifications (Preview)',
      key: 'noficiations',
      icon: 'https://dsmlib.logistics.systems/Icons/icons8-notification-64.png',
      type: ['Notifications'],
      disabled: true,
      controlKey: 'WidgetNotifications',
      moduleMapping: [
        { label: '', key: 'Haulage', link: '/Haulage/Haulage Job' },
        { label: '', key: 'WorkshopJob', link: '/Workshop/WorkshopJob' },
        { label: 'Freight Forwarding - Import Jobs', key: 'FreightImport', link: '/FrerightForwarding/Import Job' },
      ],
    },
    {
      title: 'Vehicle',
      key: 'vehicle',
      link: '/MasterFiles/OperationMaster/Vehicle',
      type: ['List'],
      controlKey: 'WidgetVehicle',
      optionsMode: true,
      fields: [
        { label: 'Vehicle #', key: 'vehicleno', primary: true },
        { label: 'Vehicle Code', key: 'vehiclecode' },
        { label: 'Category', key: 'category' },
        { label: 'Type', key: 'type' },
        { label: 'Availability', key: 'availability' },
        { label: 'Remarks', key: 'remarks', span: 2 },
        { label: 'Team', key: 'team' },
        { label: 'Sideloader', key: 'sideloader' },
        { label: 'Meter Reading', key: 'meterreading' },
        { label: 'Last Update', key: 'lastupdate' },
        { label: 'Updated By', key: 'updatedby' },
      ],
      sortFields: [
        { label: 'Vehicle Code', key: 'vehiclecode', defaultDesc: false },
        { label: 'Vehicle #', key: 'vehicleno', defaultDesc: false },
        { label: 'Team', key: 'team', defaultDesc: false },
        { label: 'Type', key: 'type', defaultDesc: false },
        { label: 'Availability', key: 'availability', defaultDesc: false },
        { label: 'Date Updated', key: 'updatedlatest', defaultDesc: true },
      ],
      fieldsActions: [...ViewEditSet('primaryValue', '/MasterFiles/OperationMaster/Vehicle')],
      listFilter: [
        {
          label: 'Team',
          key: 'team',
          filterType: 'multiselect',
        },
        {
          label: 'Vehicle Type',
          key: 'vehicletype',
          filterType: 'multiselect',
        },
        {
          label: 'Availability',
          key: 'availability',
          filterType: 'multiselect',
        },
        {
          label: 'No Queued Return After Destination',
          key: 'noqueuedreturnafterdestination',
          filterType: 'boolean',
        },
      ],
    },
    {
      title: 'Employee',
      key: 'employee',
      link: '/MasterFiles/ProfileMaster/Employee',
      type: ['List'],
      controlKey: 'WidgetEmployee',
      optionsMode: true,
      fields: [
        { label: 'Employee No.', key: 'employeeno', primary: true },
        { label: 'Name', key: 'name' },
        { label: 'Status', key: 'status' },
        { label: 'Department', key: 'department' },
        { label: 'Position', key: 'position' },
        { label: 'Branch', key: 'branch' },
        { label: 'Mobile', key: 'mobile' },
        { label: 'Email', key: 'email', span: 2 },
        { label: 'Last Update', key: 'lastupdate' },
        { label: 'Updated By', key: 'updatedby' },
      ],
      sortFields: [
        { label: 'Date Updated', key: 'updatedlatest', defaultDesc: true },
        { label: 'Name', key: 'name', defaultDesc: false },
      ],
      // fieldsActions: [...ViewEditSet('primaryValue', '/MasterFiles/ProfileMaster/Employee')],

      listFilter: [
        {
          label: 'Status',
          key: 'status',
          filterType: 'multiselect',
        },
        {
          label: 'Department',
          key: 'department',
          filterType: 'multiselect',
        },
      ],
    },
    {
      title: 'Import Job',
      key: 'freightimport',
      link: '/FreightForwarding/Import Job',
      type: ['List', 'Chart', 'Stats', 'DailyReport'],
      controlKey: 'WidgetFreightImport',
      optionsMode: true,
      fields: [
        { label: 'Job #', key: 'jobno', primary: true, sort: true },
        { label: 'Job Date', key: 'jobdatetime', sort: true },
        { label: 'Job Status', key: 'jobstate' },
        { label: 'Shipper', key: 'shipper', span: 2 },
        { label: 'Consignee', key: 'consignee', span: 2 },
        { label: 'Billing Customer', key: 'billingcustomer', span: 2 },
        { label: 'BL/Bkg Ref #', key: 'blbkgrefno' },
        { label: 'Cust. Ref #', key: 'custrefno' },
        { label: 'ETA', key: 'eta', sort: true },
        { label: 'Closing Time', key: 'closingtime', sort: true },
        { label: 'Vessel Name', key: 'vesselname', span: 2 },
        { label: 'Voy #', key: 'voyno' },
        { label: 'Port of Discharge', key: 'portofdischarge' },
        { label: 'Total Cont', key: 'totalcont' },
        { label: 'Project #', key: 'projectno' },
        { label: 'Remarks', key: 'remarks', span: 2 },
      ],
      fieldsActions: [...ViewEditSet('primaryValue', '/FreightForwarding/Import Job'), TasUpdate('primaryValue')],

      listFilter: [
        {
          label: 'Special Filters',
          key: 'specials',
          filterType: 'dropdown_list',
        },
        {
          label: 'Job Date Since',
          key: 'datesince',
          filterType: 'dropdown_list',
        },
        {
          label: 'Has Been Sent to Operations (1253A)',
          key: 'has1253a',
          filterType: 'boolean',
        },
        {
          label: 'Include Incorrect Status Updates',
          key: 'includeincorrectstatusupdates',
          filterType: 'boolean',
        },
        {
          label: 'Job #',
          key: 'jobno',
          filterType: 'string_value',
        },
        {
          label: 'Job Date',
          key: 'jobdatetime',
          filterType: 'date_range',
        },
        {
          label: 'ETA',
          key: 'eta',
          filterType: 'date_range',
        },
        {
          label: 'Closing Time',
          key: 'closingtime',
          filterType: 'date_range',
        },
        {
          label: 'Billing Customer',
          key: 'billingcustomer',
          filterType: 'multiselect',
        },
      ],

      stats: [
        { label: 'Total Jobs', key: 'importjobcount' },
        { label: 'Total Jobs Submitted to Customs', key: 'importjobsubmittedcustom' },
        { label: 'Total Paper Passed', key: 'totalpaperpass' },
        { label: 'Total Customs Jobs Released After Paper Pass', key: 'totalreleasedafterpaperpass' },
        {
          label: 'Total Customs Jobs Released After Submission to Customs',
          key: 'totalreleasedofsubmitted',
        },
        { label: 'Total Jobs Submitted, Approved & Released', key: 'totalcompletedoftotal' },
        { label: 'Total Jobs Not Submitted to Customs', key: 'importjobnotsubmitted' },
        {
          label: 'Total Jobs Not Received Released Date After Paper Pass',
          key: 'importjobpaperpassnotreeleased',
        },
      ],

      statsFilter: [
        {
          label: 'Job Date Since',
          key: 'datesince',
          filterType: 'dropdown_list',
        },
        {
          label: 'Has Been Sent to Operations (1253A)',
          key: 'has1253a',
          filterType: 'boolean',
        },
        {
          label: 'Include Incorrect Status Updates',
          key: 'includeincorrectstatusupdates',
          filterType: 'boolean',
        },
        {
          label: 'Job Date',
          key: 'jobdatetime',
          filterType: 'date_range',
        },
        {
          label: 'Billing Customer',
          key: 'billingcustomer',
          filterType: 'multiselect',
        },
      ],

      dailyReportFilter: [
        {
          label: 'Cutoff Date',
          key: 'reportdate',
          filterType: 'date_range',
          showTime: false,
        },
        {
          label: 'Include Not Sent To Operations (1253A)?',
          key: 'has1253a',
          filterType: 'boolean',
        },
        {
          label: 'Include Jobs Released More Than 2 Days Before End Date?',
          key: 'includereleasedbeforecutoff',
          filterType: 'boolean',
        },
      ],

      chartFilter: [
        { label: 'Special Filters', key: 'specials', filterType: 'dropdown_list' },
        { label: 'Job Date Since', key: 'datesince', filterType: 'dropdown_list' },
        { label: 'Has Been Sent to Operations (1253A)', key: 'has1253a', filterType: 'boolean' },
        {
          label: 'Job Date',
          key: 'jobdatetime',
          filterType: 'date_range',
        },
        {
          label: 'Billing Customer',
          key: 'billingcustomer',
          filterType: 'multiselect',
        },
      ],

      data: [
        { label: 'Customs Status', key: 'customsstatus', type: [{ key: 'Bar' }] },
        {
          label: 'Failure To Measures',
          key: 'failuremeasure',
          type: [{ key: 'Bar' }, { key: 'Doughnut', options: { legendPosition: 'right' } }],
        },
        { label: 'Job Count', key: 'jobcount', type: [{ key: 'Line' }, { key: 'Bar' }] },
        { label: 'Cumulative Job Count', key: 'cumulativejobcount', type: [{ key: 'Line' }] },
      ],
    },
    {
      title: 'Export Job',
      key: 'freightexport',
      link: '/FreightForwarding/Export Job',
      type: ['List', 'Chart', 'Stats'],
      controlKey: 'WidgetFreightExport',
      optionsMode: true,
      fields: [
        { label: 'Job #', key: 'jobno', primary: true, sort: true },
        { label: 'Job Date', key: 'jobdatetime', sort: true },
        { label: 'Job Status', key: 'jobstate' },
        { label: 'Shipper', key: 'shipper', span: 2 },
        { label: 'Consignee', key: 'consignee', span: 2 },
        { label: 'Billing Customer', key: 'billingcustomer', span: 2 },
        { label: 'BL/Bkg Ref #', key: 'blbkgrefno' },
        { label: 'Cust. Ref #', key: 'custrefno' },
        { label: 'ETA', key: 'eta', sort: true },
        { label: 'Closing Time', key: 'closingtime', sort: true },
        { label: 'Vessel Name', key: 'vesselname', span: 2 },
        { label: 'Voy #', key: 'voyno' },
        { label: 'Port of Discharge', key: 'portofdischarge' },
        { label: 'Total Cont', key: 'totalcont' },
        { label: 'Project #', key: 'projectno' },
        { label: 'Remarks', key: 'remarks', span: 2 },
      ],
      fieldsActions: [...ViewEditSet('primaryValue', '/FreightForwarding/Export Job'), TasUpdate('primaryValue')],

      listFilter: [
        {
          label: 'Special Filters',
          key: 'specials',
          filterType: 'dropdown_list',
        },
        {
          label: 'Job #',
          key: 'jobno',
          filterType: 'string_value',
        },
        {
          label: 'Job Date',
          key: 'jobdatetime',
          filterType: 'date_range',
        },
        {
          label: 'ETA',
          key: 'eta',
          filterType: 'date_range',
        },
        {
          label: 'Closing Time',
          key: 'closingtime',
          filterType: 'date_range',
        },
        {
          label: 'Billing Customer',
          key: 'billingcustomer',
          filterType: 'multiselect',
        },
      ],

      stats: [
        { label: 'Total Jobs', key: 'importjobcount' },
        { label: 'Total Jobs Submitted to Customs', key: 'importjobsubmittedcustom' },
        { label: 'Total Paper Passed', key: 'totalpaperpass' },
        { label: 'Total Customs Jobs Released After Paper Pass', key: 'totalreleasedafterpaperpass' },
        {
          label: 'Total Customs Jobs Released After Submission to Customs',
          key: 'totalreleasedofsubmitted',
        },
        { label: 'Total Jobs Submitted, Approved & Released', key: 'totalcompletedoftotal' },
        { label: 'Total Jobs Not Submitted to Customs', key: 'importjobnotsubmitted' },
        {
          label: 'Total Jobs Not Received Released Date After Paper Pass',
          key: 'importjobpaperpassnotreeleased',
        },
      ],

      statsFilter: [
        { label: 'Job Date', key: 'jobdatetime', filterType: 'date_range' },
        {
          label: 'Job Date Since',
          key: 'datesince',
          filterType: 'dropdown_list',
        },
        {
          label: 'Billing Customer',
          key: 'billingcustomer',
          filterType: 'multiselect',
        },
      ],

      chartFilter: [
        { label: 'Special Filters', key: 'specials', filterType: 'dropdown_list' },
        { label: 'Job Date Since', key: 'datesince', filterType: 'dropdown_list' },
        {
          label: 'Job Date',
          key: 'jobdatetime',
          filterType: 'date_range',
        },
        {
          label: 'Billing Customer',
          key: 'billingcustomer',
          filterType: 'multiselect',
        },
      ],

      data: [
        { label: 'Customs Status', key: 'customsstatus', type: [{ key: 'Bar' }] },
        {
          label: 'Failure To Measures',
          key: 'failuremeasure',
          type: [{ key: 'Bar' }, { key: 'Doughnut', options: { legendPosition: 'right' } }],
        },
        { label: 'Job Count', key: 'jobcount', type: [{ key: 'Line' }, { key: 'Bar' }] },
        { label: 'Cumulative Job Count', key: 'cumulativejobcount', type: [{ key: 'Line' }] },
      ],
    },

    {
      title: 'Trucking Jobs',
      key: 'truckingjob',
      link: '/Trucking/Trucking Job',
      type: ['List', 'Chart'],
      controlKey: 'WidgetTruckingJob',
      optionsMode: true,
      fields: [
        { label: 'Job #', key: 'jobno', primary: true, sort: true },
        { label: 'Job Date', key: 'jobdatetime', sort: true },
        { label: 'Job Status', key: 'jobstate' },
        { label: 'Customer', key: 'customer', span: 2 },
        { label: 'Billing Customer', key: 'billingcustomer', span: 2 },
        { label: 'Consignment #', key: 'consignmentno' },
        { label: 'DO #', key: 'dono' },
        { label: 'Project #', key: 'projectno' },
        { label: 'Cust. Ref #', key: 'custrefno' },
        { label: 'Required Date', key: 'requireddate', sort: true },
        { label: 'Pickup Location', key: 'pickuplocation', span: 2 },
        { label: 'Dropoff Location', key: 'dropofflocation', span: 2 },
        { label: 'Destination Code', key: 'destinationcode' },
        { label: 'Destination', key: 'destination', span: 2 },
        { label: 'Opr Tariff Area', key: 'oprtariffarea' },
        { label: 'Tariff Area', key: 'tariffarea' },
        { label: 'Resolved Area', key: 'resolvedarea' },
        { label: 'POD ETA', key: 'podeta', sort: true },
        { label: 'Days Pending', key: 'dayspending', sort: true },
        { label: 'Lorry #', key: 'lorryno' },
        { label: 'Driver', key: 'driver' },
        { label: 'Total Consignments', key: 'totalconsignments' },
        { label: 'Job Assigned', key: 'jobassigned' },
        { label: 'Last Update', key: 'lastupdate' },
        { label: 'Updated By', key: 'updatedby' },
      ],
      sortFields: [
        { label: 'Job #', key: 'jobno', defaultDesc: false },
        { label: 'Job Date', key: 'jobdatetime', defaultDesc: true },
        { label: 'Required Date', key: 'requireddate', defaultDesc: true },
        { label: 'Days Pending', key: 'dayspending', defaultDesc: true },
        { label: 'Destination', key: 'destination', defaultDesc: false },
        { label: 'Resolved Area', key: 'resolvedarea', defaultDesc: false },
        { label: 'POD ETA', key: 'podeta', defaultDesc: true },
        { label: 'Date Updated', key: 'updatedlatest', defaultDesc: true },
      ],
      fieldsActions: [...ViewEditSet('primaryValue', '/Trucking/Trucking Job')],
      listFilter: [
        {
          label: 'Special Filters',
          key: 'specials',
          filterType: 'dropdown_list',
          alwaysShow: true,
        },
        { label: 'Job #', key: 'jobno', filterType: 'string_value' },
        { label: 'Job Date', key: 'jobdatetime', filterType: 'date_range' },
        { label: 'Cust. Ref #', key: 'custrefno', filterType: 'string_value' },
        { label: 'DO #', key: 'dono', filterType: 'string_value' },
        { label: 'Billing Customer', key: 'billingcustomer', filterType: 'multiselect' },
        { label: 'POD Pending Over Days', key: 'poddayspending', filterType: 'number_value', validator: 'positiveInteger' },
        { label: 'Destination Area', key: 'area', filterType: 'multiselect' },
      ],
      chartFilter: [
        {
          label: 'Special Filters',
          key: 'specials',
          filterType: 'dropdown_list',
          alwaysShow: true,
        },
        { label: 'Job Date', key: 'jobdatetime', filterType: 'date_range' },
        { label: 'Billing Customer', key: 'billingcustomer', filterType: 'multiselect' },
        { label: 'Destination Area', key: 'area', filterType: 'multiselect' },
      ],
      data: [
        { label: 'Assignment Status', key: 'jobassigned', type: [{ key: 'Pie' }, { key: 'Doughnut' }, { key: 'Bar' }] },
        { label: 'Job Count', key: 'jobcount', type: [{ key: 'Line' }, { key: 'Bar' }] },
        { label: 'Resolved Area', key: 'resolvedarea', type: [{ key: 'Bar' }, { key: 'Doughnut' }] },
        { label: 'Destination', key: 'destination', type: [{ key: 'Bar' }] },
      ],
    },

    {
      title: 'Haulage',
      key: 'haulage',
      link: '/Haulage/Haulage Job',
      type: ['List', 'Chart'],
      controlKey: 'WidgetHaulage',
      optionsMode: true,
      fields: [
        { label: 'Job No', key: 'jobno', sort: true, primary: true },
        { label: 'Request No', key: 'requestno' },
        { label: 'Job Status', key: 'jobstate' },
        { label: 'Job Date', key: 'jobdatetime', sort: true },
        { label: 'Shipper', key: 'shipper', span: 2 },
        { label: 'Billing Customer', key: 'billingcustomer', span: 2 },
        { label: 'Send To Delivery Address', key: 'sendtodeliveryaddress', span: 2 },
        { label: 'Destination', key: 'destination', span: 2 },
        { label: 'Resolved Area', key: 'resolvedarea' },
        { label: 'Cust Ref No', key: 'custrefno' },
        { label: 'Inco Term', key: 'incoterm' },
        { label: 'Closing Time', key: 'closingtime' },
        { label: 'ETA', key: 'eta' },
        { label: 'BL/Bkg Ref No', key: 'blbkgrefno' },
        { label: 'Shipping Agent', key: 'shippingagent', span: 2 },
        { label: 'Ship Call No', key: 'shipcallno' },
        { label: 'Voy No', key: 'voyno' },
        { label: 'Vessel Name', key: 'vesselname', span: 2 },
        { label: 'Vessel ID', key: 'vesselid' },
        { label: 'Port Of Loading', key: 'portofloading' },
        { label: 'Station', key: 'station' },
        { label: 'Port Of Discharge', key: 'portofdischarge' },
        { label: 'Goods Desc', key: 'goodsdesc', span: 2 },
        { label: 'Packages', key: 'packages' },
        { label: 'KGM', key: 'kgm' },
        { label: 'M3', key: 'm3' },
        { label: 'Chargeable KGM', key: 'chargeablekgm' },
        { label: 'Remarks', key: 'remarks', span: 2 },
        { label: 'Consignee', key: 'consignee', span: 2 },
        { label: 'Shipping Line', key: 'shippingline', span: 2 },
        { label: 'Manifest No', key: 'manifestno' },
        { label: 'Warehouse', key: 'warehouse' },
        { label: 'Job Type', key: 'jobtype' },
        { label: 'Job Assigned', key: 'jobassigned' },
        { label: 'Total Cont', key: 'totalcont' },
        { label: 'Inv/DN Printed', key: 'invdnprinted' },
        { label: 'Project No', key: 'projectno' },
        { label: 'Pass Pend. >2d', key: 'gatepasspending' },
        { label: 'Longest Pend. Pass', key: 'gatepasoldesteta' },
      ],

      listFilter: [
        {
          label: 'Special Filters',
          key: 'specials',
          filterType: 'dropdown_list',
        },
        {
          label: 'Job #',
          key: 'jobno',
          filterType: 'string_value',
        },
        {
          label: 'Cust. Ref #',
          key: 'custrefno',
          filterType: 'string_value',
        },
        {
          label: 'Billing Customer',
          key: 'billingcustomer',
          filterType: 'multiselect',
        },
        {
          label: 'Job Date',
          key: 'jobdatetime',
          filterType: 'date_range',
        },
        {
          label: 'ETA',
          key: 'eta',
          filterType: 'date_range',
        },
        {
          label: 'Closing Time',
          key: 'closingtime',
          filterType: 'date_range',
        },
        {
          label: 'Area',
          key: 'area',
          filterType: 'multiselect',
          alwaysShow: true,
        },
      ],

      chartFilter: [
        {
          label: 'Special Filters',
          key: 'specials',
          filterType: 'dropdown_list',
        },
        {
          label: 'Job Date',
          key: 'jobdatetime',
          filterType: 'date_range',
        },
        {
          label: 'Area',
          key: 'area',
          filterType: 'multiselect',
          alwaysShow: true,
        },
      ],

      data: [
        { label: 'Job Status', key: 'jobstate', type: [{ key: 'Pie' }, { key: 'Doughnut' }, { key: 'Bar' }] },
        { label: 'Cumulative Job Count', key: 'cumulativejobcount', type: [{ key: 'Line' }] },
        { label: 'Job Count', key: 'jobcount', type: [{ key: 'Line' }, { key: 'Bar' }] },
        { label: 'Resolved Area', key: 'resolvedarea', type: [{ key: 'Bar' }, { key: 'Doughnut' }] },
        { label: 'Destination', key: 'destination', type: [{ key: 'Bar' }] },
      ],

      fieldsActions: [...ViewEditSet('primaryValue', '/FreightForwarding/Import Job')],
    },
  ];

  return { dashboard };
};

export default dashboardItemConfig;
